import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a990dearj1: FaireBrandEntity = {
  token: "b_a990dearj1",
  type: "brand",
  name: "Kathmandu Imports",
  avatarUrl:
    "https://cdn.faire.com/fastly/71e05c1f9e3f65eaea00b827ccf1c636ecf5933744db580dd294fc33666816ec.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/aff8deb2a988acf6eacb066cedf6e6d8f6235e4cf0ace26ea8dfdd7d04501d6a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/71e05c1f9e3f65eaea00b827ccf1c636ecf5933744db580dd294fc33666816ec.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aff8deb2a988acf6eacb066cedf6e6d8f6235e4cf0ace26ea8dfdd7d04501d6a.jpeg",
  location: "Alhambra, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 404,
  isInsider: true,
  description:
    "Kathmandu Imports, based out of Los Angeles, has been importing and distributing apparel and gifts from Nepal, Thailand, and India since 1997.\n\nMost of our styles are handmade and we practice Fair Trade. We have been supporting world peace meditation since our inception. We also support various charity in Nepal with our profits. Thus, your purchase makes a difference.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:11.118Z",
    importedBy: "entity-db-cli",
  },
};
